'use client';

import { Link } from '@/i18n/routing';
import { FaHome } from 'react-icons/fa';
import { HiChevronRight } from 'react-icons/hi2';

export default function BredCrum({ bredcumURL }) {
  return (
    <nav className="breadcum-main" aria-label="breadcrumb">
      <ol className="breadcrumb mb-0 flex gap-2 text-white">
        <li className="flex text-center items-center gap-2">
          <Link href="/" title="Home">
            <FaHome />
          </Link>
          <span>
            <HiChevronRight />
          </span>
        </li>
        <li aria-current="page" className="capitalize">
          {bredcumURL}
        </li>
      </ol>
    </nav>
  );
}
